import React 		from 'react';
import ReactDOM from 'react-dom';
import Highlight 		from 'react-highlight';

import BLComponent from '../core/_BLComponent.jsx';

export default class PostFeedback extends BLComponent {
	constructor(props, context) {
		super(props, context);

		this.state = {
			
		};
	}

	render() {
		return (
			<section>
				<h1>Post Feedback</h1>
				<p>This method posts a new feedback about the transaction.</p>
				<h4>Request</h4>
				<table>
					<tbody>
						<tr>
							<th>Method </th>
							<th>URI </th>
						</tr>
						<tr>
							<td> POST </td>
							<td> /feedback </td>
						</tr>
					</tbody>
				</table>
				<h4>Parameters</h4>
				<p>Do not supply a request parameter with this method.</p>
				<h4>Request body</h4>
				<p>In the request body, supply <a href="?page=resource-representations-feedback">feedback resource</a>. The feedback resource object should include:</p>
				<ul>
					<li>order_id</li>
					<li>rating</li>
					<li>comment</li>
				</ul>
				<h4>Response</h4>
				<p>If successful, this method returns <a href="?page=resource-representations-feedback">feedback resource</a> as "data" in the response body.</p>
				<h4>Example</h4>
				<ul>
					<li>
						POST /feedback
						<ul>
							<li>Creates a new feedback</li>
						</ul>
					</li>
				</ul>
			</section>
		);
	}
}